class SmoothScrollbarDirective {
    constructor($window, $rootScope) {
        this.restrict = 'A';
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.controllerAs = '$ctrl';
        this.scope = {};
    }

    link(scope, element, attrs) {
        console.log(element[0]);
        window.Scripts.Scrollbar.init(element[0], {alwaysShowTracks: true});
    }

    static directiveFactory($compile, $timeout) {
        'ngInject';
        return new SmoothScrollbarDirective($compile, $timeout);
    }
}

export default SmoothScrollbarDirective;
